<template>
  <div class="client-listing-detail-fluid">
    <div class="">
      <div class="client-listing-detail" style="padding: 10px 0px;">
        <!-- <h5 class="mt-5">個別連絡一覧</h5> -->
        <div class="template-button-block">
          <TemplateListButton
            :type="'button'"
            :btnClass="'btn message-template mr-5'"
            :label="'テンプレート一覧'"
            @click="openReplyTemplate"
          />
        </div>
        <!-- <div class="search-div" v-if="!isReceivedList">
          <p @click="showSearchModal" style="cursor: pointer;">
            送信一覧検索 ＋
          </p>
          <ContactSearch v-if="searchModal" />
        </div> -->
        <MessageTemplate ref="templateModal" />
        <div class="col-sm-12 col-12 mb-4 p-0">
          <div class="navbar">
            <router-link
              v-for="link in navbarLinks"
              :key="link.path"
              :to="link.path"
              class="navbar-item"
              :class="{ active: isActiveLink(link) }"
            >
              <p :class="{ activetext: isActiveLink(link) }">
                {{ link.label }}
              </p>
            </router-link>
          </div>
        </div>
        <div class="toggle-div" v-show="isReceivedList">
          <div class="toggle-button">
            <span class="toggle-label">全件表示</span>
            <ToggleButton
              :labels="false"
              :value="showHidden"
              @change="toggleHide()"
              class="mb-0 ml-2"
              :height="20"
              :width="40"
            />
            <span class="ml-4">ON</span>
          </div>

          <!-- <div class="extra-height" v-show="!isReceivedList" style="height: 30px;"></div> -->
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import ContactSearch from './ContactSearch.vue';
import MessageTemplateModal from '../MessageTemplate/MessageTemplateModal.vue';
import MessageTemplate from '../MessageTemplate/MessageTemplate.vue';
import TemplateListButton from '@/components/common/TemplateListButton.vue';
export default {
  name: 'ContactLists',
  data() {
    return {
      showReplyTemplate: false,
    };
  },
  components: {
    ContactSearch,
    MessageTemplateModal,
    MessageTemplate,
    TemplateListButton,
  },
  computed: {
    ...mapGetters({
      showHidden: 'getShowHidden',
      currentUser: 'getCurrentUser',
      searchModal: 'getSearchModal',
    }),
    navbarLinks() {
      const links = [
        { path: '/contact-list/received-list', label: '受信一覧' },
        { path: '/contact-list/sent-list', label: '送信一覧' },
      ];
      return links;
    },
    isReceivedList() {
      // console.log(this.$route.path == '/contact-list/received-list')
      if (this.$route.path === '/contact-list/received-list') {
        return true;
      } else {
        return false;
      }
    },
    hasContactAuthority() {
      return (
        this.currentUser &&
        this.currentUser.companyContactAuthority
      );
    },
  },
  methods: {
    ...mapMutations(['toggleHiddenContacts', 'toggleSearchModal']),
    onHideModal() {
      this.showReplyTemplate = false;
    },
    openReplyTemplate() {
      this.$refs.templateModal.show();
    },
    toggleHide() {
      this.toggleHiddenContacts();
      // console.log(this.showHidden);
    },
    isCurrentRoute(path) {
      // console.log(path);
      return this.$route.path === path;
    },
    isActiveLink(link) {
      const currentPath = this.$route.path;
      // console.log(link.path)
      return currentPath.startsWith(link.path);
    },
  },
  mounted() {
    this.changeBodyToWhite();
    const firstLink = this.navbarLinks[0];
    if (this.$route.path === '/contact-list') {
      this.$router.push(firstLink);
    }
  },
  watch: {
    currentUser(newVal) {
      if (newVal !== null) {
        if (!this.hasContactAuthority) {
          return this.$router.push('/applicant');
        }
      }
    },
  },
};
</script>

<style scoped>
.search-div {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 18px;
  color: #787878;
}
.navbar {
  display: flex;
  justify-content: space-around;
  padding: 0px !important;
  /* padding-left:10px !important; */
  border-bottom: 1px solid #617776;
  /* background-color: #f5f5f5; */
}

.navbar-item {
  /* margin-right: 10px; */
  color: #3c3c3c;
  text-decoration: none;
  font-weight: 600;
}
.navbar-item {
  width: 50%;
  height: 30px;
  text-align: center;
  font-size: 18px;
  padding: 5px;
}

.navbar-item:hover {
  border-bottom: 2px solid #036d6c;
  /* color:#fff */
}
.active {
  /* background: #036d6c; */
  border-bottom: 5px solid #036d6c;
  color: #036d6c;
}

.activetext {
  color: #036d6c;
}

.template-button-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.message-template {
  width: 200px;
  height: 50px;
  text-align: center;
  font-size: 14px;
  background: #036AC9 !important;
  color: #fff;
  padding: 8px;
  /* border: 1px solid #787878; */
  border-radius: 30px;
  text-decoration: none;
}

.message-template:hover {
  opacity: 0.9;
}

>>> .vue-js-switch {
  left: 1%;
}

.toggle-div {
  /* margin-top: 40px !important; */
  /* padding-top: 40px; */
  padding: 15px 50px;
}

.toggle-label {
  /* position: relative; */
  /* left: 10%; */
  top: 5px;
  font-size: 14px;
  color: #787878;
}
</style>
